export const MODAL_DETAIL_CONSTANTS = {
  RESUME: "Resumen de la consulta",
  NO_NOTES: "No hay notas creadas",
  BTN_SAVE_NOTE: "Guardar Nota",
  YOUR_NOTE_HERE: "Tu nota aqui",
  TASK_STATE: {
    COMPLETE: "Completada"
  }
};
